import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { detail } from "../src/modules/setting/api/actions/query"
import clientSettings from "./setup/config/clientSettings";

class PageMeta extends Component {
    state = {
        clientName: null,
    };
    componentDidMount() {
        this.fetchSettings();
    }

    fetchSettings = async () => {
        const { detail } = this.props;
        try {
            const response = await detail({ vendorId: "" });
            const vendorName = response?.data?.data?.vendor?.name;

            if (vendorName && clientSettings[vendorName]) {
                this.setState({ clientName: vendorName });
            } else {
                console.warn("Vendor name not found in clientSettings:", vendorName);
            }
        } catch (error) {
            console.error("Error fetching setting data:", error);
        }
    };

    render() {
        const { clientName } = this.state;
        const client = clientSettings[clientName] || {};
        const title = client.title || "Datumart Store Console";
        const favicon = client.favicon || "/datumart-favicon.ico";

        return (
            <Helmet>
                <title>{title}</title>
                <link rel="icon" href={favicon} />
            </Helmet>
        );
    }
}

const mapDispatchToProps = {
    detail,
};

export default connect(null, mapDispatchToProps)(PageMeta);

